import Header from "components/Headers/Header";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import Tabs from "components/Tabe";
import TableComponent from "components/TableComponent";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { getStates } from "store/actions/fanDataAction";
import { getCollegeCity } from "store/actions/schoolAction";
import { newSchoolsData } from "store/actions/schoolAction";
import { adminSendEmailSchool } from "store/actions/schoolAction";
import { GetUnRegisteredColleges } from "store/actions/schoolAction";
import { GetUnRegisteredSchools } from "store/actions/schoolAction";
import { getApprovedSchools } from "store/actions/schoolAction";
import { newCollegeUniversities } from "store/actions/schoolAction";
import { getSchoolCounty } from "store/actions/schoolAction";
import { fetchSchoolStates } from "store/actions/schoolAction";
import { fetchStates } from "store/actions/schoolAction";

const ContactSchools = () => {
  let dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("registered_school");
  const [loader, setLoader] = useState({
    data: false,
    btn: false,
    email: false,
    singleEmail: false,
  });
  const [email, setEmail] = useState("");
  const [singleEmail, setSingleEmail] = useState("");
  const [emailModal, setEmailModal] = useState(false);
  const toggleEmailModal = () => {
    setEmailModal(!emailModal);
    setSingleEmail("");
  };
  const [oneEmail, setOneEmail] = useState("");
  let [filter, setFilter] = useState({
    instituteLevel: "",
    state: "",
    city: "",
    school: "",
    date: "",
    adminName: "",
    adminEmail: "",
  });
  const {
    activeSchools,
    lastApprovedSchoolDocument,
    hasMoreApprovedSchools,
    schoolStates,
    collegeStates,
    city,
    county,
    school,
    college,
    schoolEmails,
    unRegisteredColleges,
    unRegisteredSchools,
  } = useSelector((state) => state.school);

  const infoPoints = [
    "The modules contains all the registered and verified school users. Admin can send them the email individually as well as send a message as a whole.",
  ];
  const subPoints = [
    {
      title: "Registered Schools",
      description:
        "In this tab admin can send email individually and also send email as a whole to notify the school users.",
    },
    {
      title: "Un Registerd Colleges",
      description:
        "Tab contains all the un registered colleges and filters for searching.",
    },
    {
      title: "Un Registerd High Schools",
      description:
        "Tab contains all the un registered schools and filters for searching.",
    },
  ];

  const infoTitle = "Contact Schools Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name == "instituteLevel") {
      setFilter((prev) => ({
        ...prev,
        state: "",
        city: "",
        school: "",
      }));
    } else if (name == "state") {
      setFilter((prev) => ({
        ...prev,
        city: "",
        school: "",
      }));
    } else if (name == "city") {
      setFilter((prev) => ({
        ...prev,
        school: "",
      }));
    }
  };
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const handleSendEmail = (sendOneSchool) => {
    let data = {
      emails: sendOneSchool ? [oneEmail] : schoolEmails,
      text: sendOneSchool ? singleEmail : email,
    };
    if (data.text && data.emails.length > 0) {
      setLoader((prev) => ({
        ...prev,
        singleEmail: sendOneSchool ? true : prev.singleEmail,
        email: !sendOneSchool ? true : prev.email,
      }));

      dispatch(
        adminSendEmailSchool(data, (res) => {
          setLoader((prev) => ({
            ...prev,
            email: false,
            singleEmail: false,
          }));
          if (res == "success") {
            if (sendOneSchool) {
              toggleEmailModal();
            }
            setEmail("");
          }
        })
      );
    } else {
      let errorMessage = "";

      if (!email) {
        errorMessage += "Email text cannot be empty. ";
      }

      if (schoolEmails.length === 0) {
        errorMessage += "No school emails provided.";
      }

      toast.warning(errorMessage);
    }
  };

  const getStateOptions = () => {
    const states =
      filter.instituteLevel == "High School" ? schoolStates : collegeStates;
    return states.map((item, index) => (
      <option key={index} value={item.name}>
        {item.name}
      </option>
    ));
  };
  const getCountyOptions = () => {
    const newData = filter.instituteLevel == "High School" ? county : city;
    return newData.map((item, index) => (
      <option
        key={index}
        value={filter.instituteLevel == "High School" ? item.county : item.city}
      >
        {filter.instituteLevel == "High School" ? item.county : item.city}
      </option>
    ));
  };
  const getInstituteOptions = () => {
    const instituteList =
      filter.instituteLevel == "High School" ? school : college;
    return instituteList.map((item) =>
      item.institutes.map((institute, index) => (
        <option key={index} value={institute}>
          {institute}
        </option>
      ))
    );
  };

  useEffect(() => {
    dispatch(getStates());
    dispatch(fetchStates());

    dispatch(fetchSchoolStates());
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getApprovedSchools(filter, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);
  useEffect(() => {
    if (filter.state != "") {
      if (filter.instituteLevel == "High School") {
        dispatch(getSchoolCounty(filter.state));
      } else {
        dispatch(getCollegeCity(filter.state));
      }
    }
  }, [filter.state]);
  useEffect(() => {
    if (filter.state != "" && filter.city != "") {
      if (filter.instituteLevel == "High School") {
        dispatch(newSchoolsData(filter.state, filter.city));
      } else {
        dispatch(newCollegeUniversities(filter.state, filter.city));
      }
    }
  }, [filter.state, filter.city]);

  const column = [
    // "School Admin Name",
    // "School Email",
    "School Name",
    "State",
    "City",
    "County",
    // "Created At",
  ];
  const columnColleges = ["State", "City", "School Name"];
  const columnSchools = ["State", "County", "School Name"];
  const UnRegisteredKeys = {
    State: "state",
    City: "city",
    County: "county",
    "School Name": "institute",
  };
  const keyMaps = {
    "School Name": "instituteName",
    State: "state",
    City: "city",
    County: "noCity",
  };
  const formattedData = (data) => {
    return data.map((item) => ({
      ...item,
      created_at: moment.unix(item?.created_at.seconds).format("MM-DD-YYYY"),
      city: item.instituteLevel == "High School" ? "" : item.county,
      noCity: item.instituteLevel == "High School" ? item.county : "",
    }));
  };
  const renderActionsActiveSchool = (row) => (
    <>
      <Button
        color="primary"
        size="sm"
        onClick={() => {
          toggleEmailModal();
          setOneEmail(row.email);
        }}
      >
        Send Email
      </Button>
    </>
  );
  const handleApplyFilter = () => {
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    dispatch(
      getApprovedSchools(filter, "", () => {
        setLoader((prev) => ({
          ...prev,
          btn: false,
        }));
      })
    );
  };
  const handleClearFilter = () => {
    let clearFilter = {
      instituteLevel: "",
      state: "",
      city: "",
      school: "",
      date: "",
      adminName: "",
      adminEmail: "",
    };
    dispatch(getApprovedSchools(clearFilter, "", () => {}));
    setFilter(clearFilter);
  };
  const handleGetApprovedSchools = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getApprovedSchools(filter, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const loadMoreActiveSchools = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getApprovedSchools(filter, lastApprovedSchoolDocument, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const [unRegisteredCollege, setUnRegisteredCollege] = useState({
    city: "",
    state: "",
    institute: "",
    pageSize: 4,
    lastDocId: unRegisteredColleges?.lastDocId || "",
  });
  const [unRegisteredSchool, setUnRegisteredSchool] = useState({
    county: "",
    state: "",
    institute: "",
    pageSize: 4,
    lastDocId: unRegisteredSchools?.lastDocId || "",
  });
  const [unRegisteredLoader, setUnRegisteredLoader] = useState({
    data: false,
    loadMore: false,
    applyFilter: false,
    clearFilter: false,
  });
  const handleChangeUnRegisteredCollege = (e) => {
    let { value, name } = e.target;
    setUnRegisteredCollege((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeUnRegisteredSchool = (e) => {
    let { value, name } = e.target;
    setUnRegisteredSchool((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const capitalizeWords = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const applyFilter = () => {
    setUnRegisteredLoader((prev) => ({
      ...prev,
      applyFilter: true,
    }));
    if (activeTab == "un-registered_colleges") {
      let filter = {
        city: unRegisteredCollege.city
          ? capitalizeWords(unRegisteredCollege.city)
          : "",
        state: unRegisteredCollege.state
          ? unRegisteredCollege.state.toUpperCase()
          : "",
        institute: unRegisteredCollege.institute
          ? capitalizeWords(unRegisteredCollege.institute)
          : "",
        pageSize: 4,
        lastDocId: "",
      };
      dispatch(
        GetUnRegisteredColleges(filter, () => {
          setUnRegisteredLoader((prev) => ({
            ...prev,
            applyFilter: false,
          }));
        })
      );
    } else if (activeTab == "un-registered_schools") {
      let filter = {
        county: unRegisteredSchool.county
          ? capitalizeWords(unRegisteredSchool.county)
          : "",
        state: unRegisteredSchool.state
          ? unRegisteredSchool.state.toUpperCase()
          : "",
        institute: unRegisteredSchool.institute
          ? capitalizeWords(unRegisteredSchool.institute)
          : "",
        pageSize: 4,
        lastDocId: "",
      };
      dispatch(
        GetUnRegisteredSchools(filter, () => {
          setUnRegisteredLoader((prev) => ({
            ...prev,
            applyFilter: false,
          }));
        })
      );
    }
  };
  const handleGetRegisteredColleges = () => {
    setUnRegisteredLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      GetUnRegisteredColleges(unRegisteredCollege, () => {
        setUnRegisteredLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const handleGetRegisteredSchools = () => {
    setUnRegisteredLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      GetUnRegisteredSchools(unRegisteredSchool, () => {
        setUnRegisteredLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };

  const handleClearFilters = () => {
    setUnRegisteredLoader((prev) => ({
      ...prev,
      clearFilter: true,
    }));
    let data = {
      state: "",
      institute: "",
      pageSize: 4,
      lastDocId: "",
    };
    if (activeTab == "un-registered_colleges") {
      data.city = "";
      dispatch(
        GetUnRegisteredColleges(data, () => {
          setUnRegisteredCollege((prev) => ({
            ...prev,
            city: "",
            state: "",
            institute: "",
            pageSize: 4,
            lastDocId: "",
          }));
          setUnRegisteredLoader((prev) => ({
            ...prev,
            clearFilter: false,
          }));
        })
      );
    } else if (activeTab == "un-registered_schools") {
      data.county = "";
      dispatch(
        GetUnRegisteredSchools(data, () => {
          setUnRegisteredSchool((prev) => ({
            ...prev,
            county: "",
            state: "",
            institute: "",
            pageSize: 4,
            lastDocId: "",
          }));
          setUnRegisteredLoader((prev) => ({
            ...prev,
            clearFilter: false,
          }));
        })
      );
    }
  };

  const LoadMoreGetRegisteredColleges = () => {
    setUnRegisteredLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    if (activeTab == "un-registered_colleges") {
      let loadMore = {
        ...unRegisteredCollege,
        lastDocId: unRegisteredColleges?.lastDocId,
      };
      dispatch(
        GetUnRegisteredColleges(loadMore, () => {
          setUnRegisteredLoader((prev) => ({
            ...prev,
            loadMore: false,
          }));
        })
      );
    } else if (activeTab == "un-registered_schools") {
      let loadMore = {
        ...unRegisteredSchool,
        lastDocId: unRegisteredSchools?.lastDocId,
      };
      dispatch(
        GetUnRegisteredSchools(loadMore, () => {
          setUnRegisteredLoader((prev) => ({
            ...prev,
            loadMore: false,
          }));
        })
      );
    }
  };

  const tabs = [
    {
      id: "registered_school",
      title: "Registered Schools",
      content: (
        <>
          {loader.data ? (
            <div className="text-center mt-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <Row>
                <Col className="d-flex flex-column justify-content-end align-items-end mb-4">
                  <Input
                    placeholder="Enter your message for the schools here..."
                    type="textarea"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={activeSchools.length == 0}
                  />
                  <Button
                    className="my-2 text-nowrap width-res"
                    color="primary"
                    onClick={() => {
                      handleSendEmail(false);
                    }}
                    disabled={loader.email || activeSchools.length == 0}
                  >
                    {loader.email ? <Spinner size="sm" /> : "Send Email"}
                  </Button>
                </Col>
              </Row>
              <TableComponent
                columns={column}
                data={activeSchools ? formattedData(activeSchools) : []}
                keyMap={keyMaps}
                renderActions={renderActionsActiveSchool}
              />
              {activeSchools.length > 4 && (
                <div className="text-center py-4">
                  <Button
                    color="primary"
                    onClick={loadMoreActiveSchools}
                    disabled={loader.loadMore || !hasMoreApprovedSchools}
                  >
                    {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                  </Button>
                </div>
              )}
            </>
          )}
        </>
      ),
      onClick: handleGetApprovedSchools,
    },
    {
      id: "un-registered_colleges",
      title: "Un Registered Colleges",
      content: (
        <>
          <Row className="g-3">
            <Col xs="12" md="4" lg="3" className="mb-3 mb-md-0">
              <Input
                placeholder="Enter State"
                name="state"
                value={unRegisteredCollege.state}
                onChange={handleChangeUnRegisteredCollege}
              />
            </Col>
            <Col xs="12" md="4" lg="3" className="mb-3 mb-md-0">
              <Input
                placeholder="Enter City"
                name="city"
                value={unRegisteredCollege.city}
                onChange={handleChangeUnRegisteredCollege}
              />
            </Col>
            <Col xs="12" md="4" lg="3" className="mb-3 mb-md-0">
              <Input
                placeholder="Enter College Name"
                name="institute"
                value={unRegisteredCollege.institute}
                onChange={handleChangeUnRegisteredCollege}
              />
            </Col>

            <Col
              xs="12"
              md="12"
              lg="3"
              className="d-flex justify-content-center align-items-center mt-3 mt-lg-0"
            >
              <Button
                onClick={applyFilter}
                disabled={unRegisteredLoader.applyFilter}
                size="sm"
                color="primary"
                className="mb-2 mb-md-0 me-md-2"
              >
                {unRegisteredLoader.applyFilter ? (
                  <Spinner size="sm" />
                ) : (
                  "Apply Filter"
                )}
              </Button>
              <Button
                onClick={handleClearFilters}
                disabled={unRegisteredLoader.clearFilter}
                size="sm"
                color="danger"
                className="mb-2 mb-md-0 me-md-2"
              >
                {unRegisteredLoader.clearFilter ? (
                  <Spinner size="sm" />
                ) : (
                  "Clear Filter"
                )}
              </Button>
            </Col>
          </Row>

          {unRegisteredLoader.data ? (
            <div className="text-center mt-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <TableComponent
                columns={columnColleges}
                data={
                  unRegisteredColleges.data ? unRegisteredColleges.data : []
                }
                keyMap={UnRegisteredKeys}
              />
              <div className="text-center py-4">
                <Button
                  onClick={LoadMoreGetRegisteredColleges}
                  disabled={unRegisteredLoader.loadMore}
                  color="primary"
                >
                  {unRegisteredLoader.loadMore ? (
                    <Spinner size="sm" />
                  ) : (
                    "Load More"
                  )}{" "}
                </Button>
              </div>
            </>
          )}
        </>
      ),
      onClick: handleGetRegisteredColleges,
    },
    {
      id: "un-registered_schools",
      title: "Un Registered High Schools",
      content: (
        <>
          <Row className="g-3">
            <Col xs="12" md="4" lg="3" className="mb-3 mb-md-0">
              <Input
                placeholder="Enter State"
                name="state"
                value={unRegisteredSchool.state}
                onChange={handleChangeUnRegisteredSchool}
              />
            </Col>
            <Col xs="12" md="4" lg="3" className="mb-3 mb-md-0">
              <Input
                placeholder="Enter County"
                name="county"
                value={unRegisteredSchool.county}
                onChange={handleChangeUnRegisteredSchool}
              />
            </Col>
            <Col xs="12" md="4" lg="3" className="mb-3 mb-md-0">
              <Input
                placeholder="Enter College Name"
                name="institute"
                value={unRegisteredSchool.institute}
                onChange={handleChangeUnRegisteredSchool}
              />
            </Col>
            <Col
              xs="12"
              md="12"
              lg="3"
              className="d-flex justify-content-center align-items-center mt-3 mt-lg-0"
            >
              <Button
                onClick={applyFilter}
                disabled={unRegisteredLoader.applyFilter}
                size="sm"
                color="primary"
                className="mb-2 mb-md-0 me-md-2 "
              >
                {unRegisteredLoader.applyFilter ? (
                  <Spinner size="sm" />
                ) : (
                  "Apply Filter"
                )}
              </Button>

              <Button
                onClick={handleClearFilters}
                disabled={unRegisteredLoader.clearFilter}
                size="sm"
                color="danger"
                className="mb-2 mb-md-0 me-md-2 "
              >
                {unRegisteredLoader.clearFilter ? (
                  <Spinner size="sm" />
                ) : (
                  "Clear Filter"
                )}
              </Button>
            </Col>
          </Row>
          {unRegisteredLoader.data ? (
            <div className="text-center mt-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <TableComponent
                columns={columnSchools}
                data={unRegisteredSchools.data ? unRegisteredSchools.data : []}
                keyMap={UnRegisteredKeys}
              />
              <div className="text-center py-4">
                <Button
                  onClick={LoadMoreGetRegisteredColleges}
                  disabled={unRegisteredLoader.loadMore}
                  color="primary"
                >
                  {unRegisteredLoader.loadMore ? (
                    <Spinner size="sm" />
                  ) : (
                    "Load More"
                  )}{" "}
                </Button>
              </div>
            </>
          )}
        </>
      ),
      onClick: handleGetRegisteredSchools,
    },
  ];
  return (
    <>
      <Header />

      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Card className="pb-2">
          <Tabs activeTab={activeTab} toggleTab={toggleTab} tabs={tabs} />
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={emailModal} centered size="lg" toggle={toggleEmailModal}>
        <ModalBody>
          <Label>Enter Your Message</Label>
          <Input
            placeholder="Enter your message for the school here..."
            type="textarea"
            value={singleEmail}
            onChange={(e) => setSingleEmail(e.target.value)}
          />
          <div className="text-right">
            <Button color="danger" onClick={toggleEmailModal} className="mt-3">
              Cancel
            </Button>{" "}
            <Button
              color="primary"
              disabled={loader.email || !singleEmail}
              onClick={() => {
                handleSendEmail(true);
              }}
              className="mt-3"
            >
              {loader.singleEmail ? <Spinner size="sm" /> : "Send"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ContactSchools;
